// Native
import { useState } from "react"
import { Button, Stack, Text } from "@chakra-ui/react"

// Custom
import { Form, UI } from "components"
import useUser from "hooks/useUser"

export default function Cache(){

    const user = useUser()
    const [ loading, setLoading ] = useState(false)

    const handleClean = () => {
        setLoading(true)

        localStorage.removeItem('REACT_QUERY_OFFLINE_CACHE')

        setTimeout(() => {
            window.location.reload()
        }, 2000)
    }

    return(
    <UI.Box>
        <Stack gap={4}>
            <Text color="GrayText">Performance:</Text>

            <UI.Lottie animation="cache" options={{ loop: true }} style={{ height: '180px', transform: 'scale(1.2)' }} />

            <Button colorPalette="yellow" defaultChecked={user.data?.options?.support_access} loading={loading} loadingText="Limpando cache..." onClick={handleClean}><UI.Icon name="cache" /> Limpar cache do app</Button>
            <Text fontSize="xs" color="fg.muted">Caso esteja com problemas para carregar os dados do seu escritório, tente limpar o cache do seu aplicativo. A página será recarregada em seguida.</Text>
        </Stack>
    </UI.Box>
    )
}